<span class="alertSnackbar">
    {{mensaje}}
</span>